const style ={
        colors: {
            main: "#960014",
            btnInline: "#F1F3F4",
            btnInlineBorder: "#DCDFE3",
            btnSecondHover: "#DCDFE3",
            inpBorder: "#DCDFE3",
            inpFocusBorder: "#B4B8BE" ,
            font: "#595E69",
            inactive: "rgba(150,0,20,0.5)"
        }
    }

export default style